import BaseObject from './BaseObject';
import { Matrix4, Mesh } from 'three';
import { TranslateBlockObjectDescription, MaterialTypes, ObjectTypes } from '@data/models';
import { GeometryProvider, MaterialsProvider } from '@data/providers';
import { WebGLScene } from '../WebGLScene';
import { Dictionary } from '@types';
import ToothObject from './ToothObject';


class TranslateBlockObject extends BaseObject {
  constructor(mesh: Mesh) {
    super(mesh, ObjectTypes.TranslateBlock);
  }

  static async create(
    description: TranslateBlockObjectDescription,
    scene: WebGLScene,
    geometryProvider: GeometryProvider,
    materialsProvider: MaterialsProvider
  ) {
    const mesh = new Mesh(
      geometryProvider.getGeometryByDescription(description),
      materialsProvider.getMaterial(MaterialTypes.TranslateBlock, undefined, description.jaw)
    );

    const position = mesh.position.clone();
    const rotation = mesh.rotation.clone();
    const scale = mesh.scale.clone();

    if (description.transform) {
      const matrix = new Matrix4();
      matrix.fromArray(description.transform);
      matrix.transpose();
      mesh.applyMatrix4(matrix);
    }

    const obj = new TranslateBlockObject(mesh);
    obj.setInitial(position, rotation, scale);
    scene.getRootObject().add(obj.mesh);

    obj.id = description.id;
    obj.visible = description.visible;

    return obj;
  }

  async update(description: TranslateBlockObjectDescription, objects: Dictionary<BaseObject>) {
    await super.update(description, objects);
    const mesh = this._mesh as Mesh;
    ToothObject.updateSemitransparency(mesh, description.isSemitransparent);
  }
}

export default TranslateBlockObject;

